import { Button, Callout, PageHeader } from "@moneymap/ui";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApi } from "../api/ApiProvider";
import {
  openPlaidLink,
  PLAID_OAUTH_RETURN_PATH_KEY,
  PLAID_OAUTH_TOKEN_KEY,
} from "../lib/plaid-link";

function safeReturnPath(): string {
  const saved = sessionStorage.getItem(PLAID_OAUTH_RETURN_PATH_KEY);
  return saved?.startsWith("/") && !saved.startsWith("//") ? saved : "/settings/connections";
}

export function PlaidOAuthPage() {
  const api = useApi();
  const navigate = useNavigate();
  const started = useRef(false);
  const [error, setError] = useState<string>();

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const linkToken = sessionStorage.getItem(PLAID_OAUTH_TOKEN_KEY);
    const returnPath = safeReturnPath();
    if (!linkToken) {
      setError("This bank connection expired. Start again from Accounts & imports.");
      return;
    }
    void openPlaidLink(linkToken, window.location.href)
      .then(async (publicToken) => {
        if (!publicToken) {
          navigate(returnPath, { replace: true });
          return;
        }
        await api.exchangePlaidPublicToken(publicToken);
        sessionStorage.removeItem(PLAID_OAUTH_TOKEN_KEY);
        sessionStorage.removeItem(PLAID_OAUTH_RETURN_PATH_KEY);
        navigate(returnPath, { replace: true });
      })
      .catch((cause: unknown) => {
        setError(cause instanceof Error ? cause.message : "The bank connection could not resume.");
      });
  }, [api, navigate]);

  return (
    <div className="page-stack">
      <PageHeader
        eyebrow="Secure bank connection"
        title="Returning to Plaid"
        description="IterNest Money is restoring the connection you started."
      />
      {error ? (
        <Callout title="Connection not completed" tone="urgent">
          {error}
        </Callout>
      ) : (
        <Callout title="Opening Plaid" tone="info">
          Keep this page open while the secure connection resumes.
        </Callout>
      )}
      <Button type="button" variant="secondary" onClick={() => navigate(safeReturnPath())}>
        Return to accounts
      </Button>
    </div>
  );
}
